(function () {
    'use strict';

    angular.module("imApp").factory("traceSearchService", ['$ihttp', function ($ihttp) {
        let service = {
            getTraceSearch: function (parms) {
                return $ihttp.post({
                    method: 2453,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
